//our root app component
import {single, multi} from './data';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {ActivatedRoute} from '@angular/router';
import {Routes, RouterModule} from '@angular/router';
import {Http, Response} from '@angular/http';

@Component({
  selector: 'd3graph-app',
  templateUrl: './d3graph.component.html',
  styleUrls: ['./d3graph.component.css']
})
export class D3graphComponent {

  private apiUrl = "/assets/data/db.json";

  sifProjects: any = {};
  single: any[];
  multi: any[];
  data511: any[];
  data512: any[];
  data513: any[];
  data514: any[];
  data521: any[];
  data531: any[];
  data532: any[];
  data533: any[];
  data541: any[];
  data542: any[];
  data543: any[];
  data551: any[];
  data552: any[];
  data553: any[];
  data554: any[];
  data555: any[];
  data556: any[];
  data561: any[];
  data562: any[];
  data563: any[];
  data564: any[];
  data5b1: any[];
  data5c1: any[];
  newArray: any;
  countries: any[]
  seriesData: any;
  matchId: string;
  initiativeID: string;
  initative: any[];
  allDataFetched: boolean = false;
  view: any[] = [700, 500];

  // options
  showXAxis = false;
  showYAxis = true;
  gradient = false;
  showLegend = false;
  showXAxisLabel = false;
  xAxisLabel = 'Year';
  showYAxisLabel = true;
  yAxisLabel = 'Percentage';
  yNumberLabel = 'Number';
  yScaleMin= 0;
  yScaleMax= 100;

  colorScheme = {
    // domain: ['#5AA454', '#A10A28', '#C7B42C', '#AAAAAA']
    domain: ['#5AA454']
  };
  // line, area
  // autoScale = false;

constructor(private http: Http, route: ActivatedRoute, private router: Router){

    Object.assign(this, {single, multi})
    this.initiativeID = route.snapshot.params['id'];
    this.matchId = route.snapshot.params['id'];


}

    getData(){
     return this.http.get(this.apiUrl)
       .map((res: Response) => res.json())
    }

    getProjects(){
     this.getData().subscribe(data => {
         this.sifProjects = data;
         this.countries = this.sifProjects;

         this.initative = this.countries.filter(
              country => country.countryName === this.matchId);
              this.create511();
              this.create512();
              this.create513();
              this.create514();
              this.create521();
              this.create531();
              this.create532();
              this.create533();
              this.create541();
              this.create542();
              this.create543();
              this.create551();
              this.create552();
              this.create553();
              this.create554();
              this.create555();
              this.create556();
              this.create561();
              this.create562();
              this.create563();
              this.create564();
              this.create5b1();
              this.create5c1();
              
              this.allDataFetched = true;

     })


    }

  onSelect(event) {

  }


create511(){

  if(this.initative[0].series.SG_LGL_GENEQLFP){
  this.seriesData = [];

          for(var i=0; i<this.initative[0].series.SG_LGL_GENEQLFP.data.length; i++){
            var obj = {};
            if (this.initative[0].series.SG_LGL_GENEQLFP.data.length == 1){
              obj['name'] = 'Most Recent Year';  
            }
           else if (i == 0){
              obj['name'] = 'First Reported Year';  
            }
            else if (i == this.initative[0].series.SG_LGL_GENEQLFP.data.length-1){
              obj['name'] = 'Most Recent Year';  
            }
            else {
              var additive = (i + 1);
              obj['name'] = "Year " + additive 
            }
            obj['value'] = this.initative[0].series.SG_LGL_GENEQLFP.data[i];  
            this.seriesData.push(obj);
              }
        this.data511 = this.seriesData
  }
}

create512(){
  
  if(this.initative[0].series.SG_LGL_GENEQVAW){
  this.seriesData = [];
     
          for(var i=0; i<this.initative[0].series.SG_LGL_GENEQVAW.data.length; i++){
            var obj = {};
            if (this.initative[0].series.SG_LGL_GENEQVAW.data.length == 1){
              obj['name'] = 'Most Recent Year';  
            }
           else if (i == 0){
              obj['name'] = 'First Reported Year';  
            }
            else if (i == this.initative[0].series.SG_LGL_GENEQVAW.data.length-1){
              obj['name'] = 'Most Recent Year';  
            }
            else {
              var additive = (i + 1);
              obj['name'] = "Year " + additive 
            }
            obj['value'] = this.initative[0].series.SG_LGL_GENEQVAW.data[i];  
            this.seriesData.push(obj);
              }
        this.data512 = this.seriesData
            }
}

create513(){
  if(this.initative[0].series.SG_LGL_GENEQEMP){
      this.seriesData = [];

              for(var i=0; i<this.initative[0].series.SG_LGL_GENEQEMP.data.length; i++){
                var obj = {};
                if (this.initative[0].series.SG_LGL_GENEQEMP.data.length == 1){
                  obj['name'] = 'Most Recent Year';  
                }
               else if (i == 0){
                  obj['name'] = 'First Reported Year';  
                }
                else if (i == this.initative[0].series.SG_LGL_GENEQEMP.data.length-1){
                  obj['name'] = 'Most Recent Year';  
                }
                else {
                  var additive = (i + 1);
                  obj['name'] = "Year " + additive 
                }
                obj['value'] = this.initative[0].series.SG_LGL_GENEQEMP.data[i];  
                this.seriesData.push(obj);
                  }

            this.data513 = this.seriesData
                }
}

create514(){
  if(this.initative[0].series.SG_LGL_GENEQMAR){
  this.seriesData = [];

          for(var i=0; i<this.initative[0].series.SG_LGL_GENEQMAR.data.length; i++){
            var obj = {};
            if (this.initative[0].series.SG_LGL_GENEQMAR.data.length == 1){
              obj['name'] = 'Most Recent Year';  
            }
           else if (i == 0){
              obj['name'] = 'First Reported Year';  
            }
            else if (i == this.initative[0].series.SG_LGL_GENEQMAR.data.length-1){
              obj['name'] = 'Most Recent Year';  
            }
            else {
              var additive = (i + 1);
              obj['name'] = "Year " + additive 
            }
            obj['value'] = this.initative[0].series.SG_LGL_GENEQMAR.data[i];  
            this.seriesData.push(obj);
              }
    
        this.data514 = this.seriesData
            }
}

create521(){
  if(this.initative[0].series.VC_VAW_MARR){
   this.seriesData = [];

        for(var i=0; i<this.initative[0].series.VC_VAW_MARR.data.length; i++){
        var obj = {};
        if (this.initative[0].series.VC_VAW_MARR.data.length == 1){
          obj['name'] = 'Most Recent Year';  
        }
       else if (i == 0){
          obj['name'] = 'First Reported Year';  
        }
        else if (i == this.initative[0].series.VC_VAW_MARR.data.length-1){
          obj['name'] = 'Most Recent Year';  
        }
        else {
          var additive = (i + 1);
          obj['name'] = "Year " + additive 
        }
        obj['value'] = this.initative[0].series.VC_VAW_MARR.data[i];  
        this.seriesData.push(obj);
          }

        this.data521 = this.seriesData
        }
}

create531(){
  if(this.initative[0].series.SP_DYN_MRBF15){
  this.seriesData = [];

       for(var i=0; i<this.initative[0].series.SP_DYN_MRBF15.data.length; i++){
       var obj = {};
       if (this.initative[0].series.SP_DYN_MRBF15.data.length == 1){
         obj['name'] = 'Most Recent Year';  
       }
      else if (i == 0){
         obj['name'] = 'First Reported Year';  
       }
       else if (i == this.initative[0].series.SP_DYN_MRBF15.data.length-1){
         obj['name'] = 'Most Recent Year';  
       }
       else {
         var additive = (i + 1);
         obj['name'] = "Year " + additive 
       }
       obj['value'] = this.initative[0].series.SP_DYN_MRBF15.data[i];  
       this.seriesData.push(obj);
         }

       this.data531 = this.seriesData
        }
}

create532(){
  if(this.initative[0].series.SP_DYN_MRBF18){
  this.seriesData = [];

       for(var i=0; i<this.initative[0].series.SP_DYN_MRBF18.data.length; i++){
       var obj = {};
       if (this.initative[0].series.SP_DYN_MRBF18.data.length == 1){
         obj['name'] = 'Most Recent Year';  
       }
      else if (i == 0){
         obj['name'] = 'First Reported Year';  
       }
       else if (i == this.initative[0].series.SP_DYN_MRBF18.data.length-1){
         obj['name'] = 'Most Recent Year';  
       }
       else {
         var additive = (i + 1);
         obj['name'] = "Year " + additive 
       }
       obj['value'] = this.initative[0].series.SP_DYN_MRBF18.data[i];  
       this.seriesData.push(obj);
         }

       this.data532 = this.seriesData
        }
}

create533(){
  if(this.initative[0].series.SH_STA_FGMS){
  this.seriesData = [];

       for(var i=0; i<this.initative[0].series.SH_STA_FGMS.data.length; i++){
       var obj = {};
       if (this.initative[0].series.SH_STA_FGMS.data.length == 1){
         obj['name'] = 'Most Recent Year';  
       }
      else if (i == 0){
         obj['name'] = 'First Reported Year';  
       }
       else if (i == this.initative[0].series.SH_STA_FGMS.data.length-1){
         obj['name'] = 'Most Recent Year';  
       }
       else {
         var additive = (i + 1);
         obj['name'] = "Year " + additive 
       }
       obj['value'] = this.initative[0].series.SH_STA_FGMS.data[i];  
       this.seriesData.push(obj);
         }

       this.data533 = this.seriesData
        }
}

create541(){
  
  if(this.initative[0].series.SL_DOM_TSPDCW){
  this.seriesData = [];

       for(var i=0; i<this.initative[0].series.SL_DOM_TSPDCW.data.length; i++){
       var obj = {};
       if (this.initative[0].series.SL_DOM_TSPDCW.data.length == 1){
         obj['name'] = 'Most Recent Year';  
       }
      else if (i == 0){
         obj['name'] = 'First Reported Year';  
       }
       else if (i == this.initative[0].series.SL_DOM_TSPDCW.data.length-1){
         obj['name'] = 'Most Recent Year';  
       }
       else {
         var additive = (i + 1);
         obj['name'] = "Year " + additive 
       }
       obj['value'] = this.initative[0].series.SL_DOM_TSPDCW.data[i];  
       this.seriesData.push(obj);
         }

       this.data541 = this.seriesData
      }
}

create542(){

  if(this.initative[0].series.SL_DOM_TSPD){
  this.seriesData = [];

       for(var i=0; i<this.initative[0].series.SL_DOM_TSPD.data.length; i++){
       var obj = {};
       if (this.initative[0].series.SL_DOM_TSPD.data.length == 1){
         obj['name'] = 'Most Recent Year';  
       }
      else if (i == 0){
         obj['name'] = 'First Reported Year';  
       }
       else if (i == this.initative[0].series.SL_DOM_TSPD.data.length-1){
         obj['name'] = 'Most Recent Year';  
       }
       else {
         var additive = (i + 1);
         obj['name'] = "Year " + additive 
       }
       obj['value'] = this.initative[0].series.SL_DOM_TSPD.data[i];  
       this.seriesData.push(obj);
         }

       this.data542 = this.seriesData
        }

}

create543(){
  
  if(this.initative[0].series.SL_DOM_TSPDDC){
  this.seriesData = [];

       for(var i=0; i<this.initative[0].series.SL_DOM_TSPDDC.data.length; i++){
       var obj = {};
       if (this.initative[0].series.SL_DOM_TSPDDC.data.length == 1){
         obj['name'] = 'Most Recent Year';  
       }
      else if (i == 0){
         obj['name'] = 'First Reported Year';  
       }
       else if (i == this.initative[0].series.SL_DOM_TSPDDC.data.length-1){
         obj['name'] = 'Most Recent Year';  
       }
       else {
         var additive = (i + 1);
         obj['name'] = "Year " + additive 
       }
       obj['value'] = this.initative[0].series.SL_DOM_TSPDDC.data[i];  
       this.seriesData.push(obj);
         }

       this.data543 = this.seriesData
        }

}

create551(){
  
  if(this.initative[0].series.SG_GEN_PARLN){
  this.seriesData = [];

       for(var i=0; i<this.initative[0].series.SG_GEN_PARLN.data.length; i++){
       var obj = {};
       if (this.initative[0].series.SG_GEN_PARLN.data.length == 1){
         obj['name'] = 'Most Recent Year';  
       }
      else if (i == 0){
         obj['name'] = 'First Reported Year';  
       }
       else if (i == this.initative[0].series.SG_GEN_PARLN.data.length-1){
         obj['name'] = 'Most Recent Year';  
       }
       else {
         var additive = (i + 1);
         obj['name'] = "Year " + additive 
       }
       obj['value'] = this.initative[0].series.SG_GEN_PARLN.data[i];  
       this.seriesData.push(obj);
         }

       this.data551 = this.seriesData
        }

}

create552(){
  
  if(this.initative[0].series.SG_GEN_PARLNT){
  this.seriesData = [];

       for(var i=0; i<this.initative[0].series.SG_GEN_PARLNT.data.length; i++){
       var obj = {};
       if (this.initative[0].series.SG_GEN_PARLNT.data.length == 1){
         obj['name'] = 'Most Recent Year';  
       }
      else if (i == 0){
         obj['name'] = 'First Reported Year';  
       }
       else if (i == this.initative[0].series.SG_GEN_PARLNT.data.length-1){
         obj['name'] = 'Most Recent Year';  
       }
       else {
         var additive = (i + 1);
         obj['name'] = "Year " + additive 
       }
       obj['value'] = this.initative[0].series.SG_GEN_PARLNT.data[i];  
       this.seriesData.push(obj);
         }

       this.data552 = this.seriesData
        }

}

create553(){
  
  if(this.initative[0].series.SG_GEN_LOCGELS){
  this.seriesData = [];

       for(var i=0; i<this.initative[0].series.SG_GEN_LOCGELS.data.length; i++){
       var obj = {};
       if (this.initative[0].series.SG_GEN_LOCGELS.data.length == 1){
         obj['name'] = 'Most Recent Year';  
       }
      else if (i == 0){
         obj['name'] = 'First Reported Year';  
       }
       else if (i == this.initative[0].series.SG_GEN_LOCGELS.data.length-1){
         obj['name'] = 'Most Recent Year';  
       }
       else {
         var additive = (i + 1);
         obj['name'] = "Year " + additive 
       }
       obj['value'] = this.initative[0].series.SG_GEN_LOCGELS.data[i];  
       this.seriesData.push(obj);
         }

       this.data553 = this.seriesData
        }

}

create554(){
  
  if(this.initative[0].series.SG_GEN_PARL){
  this.seriesData = [];

       for(var i=0; i<this.initative[0].series.SG_GEN_PARL.data.length; i++){
       var obj = {};
       if (this.initative[0].series.SG_GEN_PARL.data.length == 1){
         obj['name'] = 'Most Recent Year';  
       }
      else if (i == 0){
         obj['name'] = 'First Reported Year';  
       }
       else if (i == this.initative[0].series.SG_GEN_PARL.data.length-1){
         obj['name'] = 'Most Recent Year';  
       }
       else {
         var additive = (i + 1);
         obj['name'] = "Year " + additive 
       }
       obj['value'] = this.initative[0].series.SG_GEN_PARL.data[i];  
       this.seriesData.push(obj);
         }

       this.data554 = this.seriesData
        }

}

create555(){
  
  if(this.initative[0].series.IC_GEN_MGTL){
  this.seriesData = [];

       for(var i=0; i<this.initative[0].series.IC_GEN_MGTL.data.length; i++){
       var obj = {};
       if (this.initative[0].series.IC_GEN_MGTL.data.length == 1){
         obj['name'] = 'Most Recent Year';  
       }
      else if (i == 0){
         obj['name'] = 'First Reported Year';  
       }
       else if (i == this.initative[0].series.IC_GEN_MGTL.data.length-1){
         obj['name'] = 'Most Recent Year';  
       }
       else {
         var additive = (i + 1);
         obj['name'] = "Year " + additive 
       }
       obj['value'] = this.initative[0].series.IC_GEN_MGTL.data[i];  
       this.seriesData.push(obj);
         }

       this.data555 = this.seriesData
        }

}

create556(){
  
  if(this.initative[0].series.IC_GEN_MGTN){
  this.seriesData = [];

       for(var i=0; i<this.initative[0].series.IC_GEN_MGTN.data.length; i++){
       var obj = {};
       if (this.initative[0].series.IC_GEN_MGTN.data.length == 1){
         obj['name'] = 'Most Recent Year';  
       }
      else if (i == 0){
         obj['name'] = 'First Reported Year';  
       }
       else if (i == this.initative[0].series.IC_GEN_MGTN.data.length-1){
         obj['name'] = 'Most Recent Year';  
       }
       else {
         var additive = (i + 1);
         obj['name'] = "Year " + additive 
       }
       obj['value'] = this.initative[0].series.IC_GEN_MGTN.data[i];  
       this.seriesData.push(obj);
         }

       this.data556 = this.seriesData
        }

}

create561(){
  
  if(this.initative[0].series.SH_FPL_INFMCU){
  this.seriesData = [];

       for(var i=0; i<this.initative[0].series.SH_FPL_INFMCU.data.length; i++){
       var obj = {};
       if (this.initative[0].series.SH_FPL_INFMCU.data.length == 1){
         obj['name'] = 'Most Recent Year';  
       }
      else if (i == 0){
         obj['name'] = 'First Reported Year';  
       }
       else if (i == this.initative[0].series.SH_FPL_INFMCU.data.length-1){
         obj['name'] = 'Most Recent Year';  
       }
       else {
         var additive = (i + 1);
         obj['name'] = "Year " + additive 
       }
       obj['value'] = this.initative[0].series.SH_FPL_INFMCU.data[i];  
       this.seriesData.push(obj);
         }

       this.data561 = this.seriesData
        }

}

create562(){
  
  if(this.initative[0].series.SH_FPL_INFMRH){
  this.seriesData = [];

       for(var i=0; i<this.initative[0].series.SH_FPL_INFMRH.data.length; i++){
       var obj = {};
       if (this.initative[0].series.SH_FPL_INFMRH.data.length == 1){
         obj['name'] = 'Most Recent Year';  
       }
      else if (i == 0){
         obj['name'] = 'First Reported Year';  
       }
       else if (i == this.initative[0].series.SH_FPL_INFMRH.data.length-1){
         obj['name'] = 'Most Recent Year';  
       }
       else {
         var additive = (i + 1);
         obj['name'] = "Year " + additive 
       }
       obj['value'] = this.initative[0].series.SH_FPL_INFMRH.data[i];  
       this.seriesData.push(obj);
         }

       this.data562 = this.seriesData
        }

}


create563(){
  
  if(this.initative[0].series.SH_FPL_INFMSR){
  this.seriesData = [];

       for(var i=0; i<this.initative[0].series.SH_FPL_INFMSR.data.length; i++){
       var obj = {};
       if (this.initative[0].series.SH_FPL_INFMSR.data.length == 1){
         obj['name'] = 'Most Recent Year';  
       }
      else if (i == 0){
         obj['name'] = 'First Reported Year';  
       }
       else if (i == this.initative[0].series.SH_FPL_INFMSR.data.length-1){
         obj['name'] = 'Most Recent Year';  
       }
       else {
         var additive = (i + 1);
         obj['name'] = "Year " + additive 
       }
       obj['value'] = this.initative[0].series.SH_FPL_INFMSR.data[i];  
       this.seriesData.push(obj);
         }

       this.data563 = this.seriesData
        }

}

create564(){
  
  if(this.initative[0].series.SH_FPL_INFM){
  this.seriesData = [];

       for(var i=0; i<this.initative[0].series.SH_FPL_INFM.data.length; i++){
       var obj = {};
       if (this.initative[0].series.SH_FPL_INFM.data.length == 1){
         obj['name'] = 'Most Recent Year';  
       }
      else if (i == 0){
         obj['name'] = 'First Reported Year';  
       }
       else if (i == this.initative[0].series.SH_FPL_INFM.data.length-1){
         obj['name'] = 'Most Recent Year';  
       }
       else {
         var additive = (i + 1);
         obj['name'] = "Year " + additive 
       }
       obj['value'] = this.initative[0].series.SH_FPL_INFM.data[i];  
       this.seriesData.push(obj);
         }

       this.data564 = this.seriesData
        }

}

create5b1(){
  
  if(this.initative[0].series.IT_MOB_OWN){
  this.seriesData = [];

       for(var i=0; i<this.initative[0].series.IT_MOB_OWN.data.length; i++){
       var obj = {};
       if (this.initative[0].series.IT_MOB_OWN.data.length == 1){
         obj['name'] = 'Most Recent Year';  
       }
      else if (i == 0){
         obj['name'] = 'First Reported Year';  
       }
       else if (i == this.initative[0].series.IT_MOB_OWN.data.length-1){
         obj['name'] = 'Most Recent Year';  
       }
       else {
         var additive = (i + 1);
         obj['name'] = "Year " + additive 
       }
       obj['value'] = this.initative[0].series.IT_MOB_OWN.data[i];  
       this.seriesData.push(obj);
         }

       this.data5b1 = this.seriesData
        }

}

create5c1(){
  
  if(this.initative[0].series.SG_GEN_EQPWN){
  this.seriesData = [];

       for(var i=0; i<this.initative[0].series.SG_GEN_EQPWN.data.length; i++){
       var obj = {};
       if (this.initative[0].series.SG_GEN_EQPWN.data.length == 1){
         obj['name'] = 'Most Recent Year';  
       }
      else if (i == 0){
         obj['name'] = 'First Reported Year';  
       }
       else if (i == this.initative[0].series.SG_GEN_EQPWN.data.length-1){
         obj['name'] = 'Most Recent Year';  
       }
       else {
         var additive = (i + 1);
         obj['name'] = "Year " + additive 
       }
       obj['value'] = this.initative[0].series.SG_GEN_EQPWN.data[i];  
       this.seriesData.push(obj);
         }

       this.data5c1 = this.seriesData
        }

}



is51Available() {
  if (!this.data511 && !this.data512 && !this.data513 && !this.data514) {
      return true;
  } else {
      return false;
  }
}

is52Available() {
  if (!this.data521) {
      return true;
  } else {
      return false;
  }
}

is53Available() {
  if (!this.data531 && !this.data532) {
      return true;
  } else {
      return false;
  }
}

is54Available() {
  if (!this.data541 && !this.data542 && !this.data543) {
      return true;
  } else {
      return false;
  }
}

is55Available() {
  if (!this.data551 && !this.data552 && !this.data553 && !this.data554 && !this.data555 && !this.data556) {
      return true;
  } else {
      return false;
  }
}

is56Available() {
  if (!this.data561 && !this.data562 && !this.data563 && !this.data564) {
      return true;
  } else {
      return false;
  }
}

is5bAvailable() {
  if (!this.data5b1) {
      return true;
  } else {
      return false;
  }
}

is5cAvailable() {
  if (!this.data5c1) {
      return true;
  } else {
      return false;
  }
}

ngOnInit(){

this.getProjects();

}

  onBack() {
    this.router.navigate(['/', 'home']);
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/d3graph/d3graph.component.ts